// トースト通知。成功通知(例:「変更を保存しました」)用の軽量な一時表示。
// エラーは BonatitanAlert(warning) で表示する方針なので、toast は成功系のみ。
// module-level の singleton state(useModal / useLock と同方針)。SPA(ssr:false)前提。
import { readonly, ref } from 'vue'

/** 自動的に消えるまでのミリ秒(モック準拠 3 秒)。 */
export const TOAST_AUTO_HIDE_MS = 3000

const message = ref('')
const visible = ref(false)
let timer: ReturnType<typeof setTimeout> | undefined

const hide = () => {
  visible.value = false
  if (timer) {
    clearTimeout(timer)
    timer = undefined
  }
}

/** メッセージを表示し、durationMs 後に自動で隠す。連続呼び出しは前のタイマーを破棄。 */
const show = (msg: string, durationMs = TOAST_AUTO_HIDE_MS) => {
  message.value = msg
  visible.value = true
  if (timer) {
    clearTimeout(timer)
    timer = undefined
  }
  timer = setTimeout(hide, durationMs)
}

export const useToast = () => {
  return {
    message: readonly(message),
    visible: readonly(visible),
    show,
    hide,
  }
}
